import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import PRODUCTION_REFERRERS_STATS_QUERY from '../../../../graphql/ProductionReferrers';
import LabelValueStats from '../../../../components/LabelValueStats';

class Referrers extends Component {
  render() {
    return (
      <LabelValueStats
        sectionTitle="Estadísticas de origenes"
        title="Origenes"
        list={this.props.stats}
      />
    );
  }
}

Referrers.propTypes = {
  id: PropTypes.string.isRequired,
};

const withReferrersStats = graphql(PRODUCTION_REFERRERS_STATS_QUERY, {
  options: ({ id }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      id,
    },
  }),
  props: ({ data }) => ({
    stats: data.getProductionReferrers ? data.getProductionReferrers.map(i => ({
      label: i.referrer,
      value: i.count,
    })) : [],
  }),
});

export default withReferrersStats(Referrers);



// WEBPACK FOOTER //
// ./src/containers/Admin/Analytics/Productions/referrers.js